export default {
      id: "mailinglist-usage",
      viewBox: "0 0 53 54",
      url: "/" + "sprite.svg#mailinglist",
      toString: function () {
        return this.url;
      }
    }